export const QualtricsContainer = (
  props: JSX.IntrinsicElements["div"] & Required<Pick<JSX.IntrinsicElements["div"], "id">>,
) => <div {...props} />;
